import { Button } from "../ui/button";
import { Trash2, Layout, Clapperboard } from "lucide-react";

export default function FormationsList({ formations, currentId, onLoad, onRemove }) {
  return (
    <div className="space-y-2">
      {formations.map((f) => {
        const active = currentId === f.id;
        const multiFrame = (f.frames?.length || 1) > 1;
        return (
          <div
            key={f.id}
            className={`group p-3 rounded-xl border text-sm flex items-center gap-2 transition ${
              active ? "border-sky-400 bg-sky-50 ring-2 ring-sky-200" : "border-slate-200 hover:bg-slate-50"
            }`}
            data-testid={`saved-formation-${f.id}`}
          >
            <button
              onClick={() => onLoad(f)}
              className="flex-1 text-left min-w-0"
              data-testid={`load-formation-${f.id}`}
            >
              <div className="font-medium truncate flex items-center gap-1.5">
                {multiFrame && <Clapperboard size={12} className="text-sky-500 shrink-0" />}
                {f.name}
              </div>
              <div className="text-xs text-slate-500">
                {f.scheme}
                {multiFrame && ` · ${f.frames.length} frame`}
              </div>
            </button>
            <Button size="icon" variant="ghost" onClick={() => onRemove(f.id)} className="opacity-50 group-hover:opacity-100">
              <Trash2 size={13} className="text-red-500" />
            </Button>
          </div>
        );
      })}
      {formations.length === 0 && (
        <div className="text-sm text-slate-500 text-center py-10">
          <Layout size={28} className="mx-auto mb-2 text-slate-300" />
          <p className="font-medium">Nessuno schema salvato</p>
          <p className="text-xs text-slate-400 mt-1">Crea il tuo primo schema tattico</p>
        </div>
      )}
    </div>
  );
}
